/* eslint-disable import/order */
import { MenuIdPlans } from '@jira/navigation-apps__constants/src/MenuIdPlans.tsx';
import { planViewNotFoundPageEntrypoint } from '@jira/spa-apps__error-pages-plan-view-not-found/src/planViewNotFoundPageEntrypoint.entrypoint.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarPlanResources,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { planViewNotFoundRoute } from '@jira/router-routes__advanced-roadmaps-routes/src/planViewNotFoundRoute.tsx';
import { composeLayouts } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { planLayout } from '@jira/platform__layouts-jira-plan-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const planViewNotFoundRouteEntry: Route = createEntry(planViewNotFoundRoute, () => ({
	group: 'software',
	layout: composeLayouts(globalLayout, planLayout),

	navigation: {
		menuId: MenuIdPlans,
	},

	resources: [...getNavigationResources(), ...getNavigationSidebarPlanResources()],

	preloadOptions: {
		earlyChunks: ['advanced-roadmaps-early-entry'],
	},

	entryPoint: () => planViewNotFoundPageEntrypoint,

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
